import { cn } from "~/lib/utils";

type Tone = "success" | "error" | "info";

type DipStatusBannerProps = {
  tone: Tone;
  icon: React.ReactNode;
  title: React.ReactNode;
  actions?: React.ReactNode;
};

const toneClasses: Record<Tone, { outer: string; icon: string }> = {
  success: { outer: "border-score-a bg-score-a-bg", icon: "bg-score-a" },
  error: { outer: "border-score-c bg-score-c-bg", icon: "bg-score-c" },
  info: { outer: "border-score-b bg-score-b-bg", icon: "bg-score-b" },
};

export function DipStatusBanner({ tone, icon, title, actions }: DipStatusBannerProps) {
  const classes = toneClasses[tone];
  return (
    <div className={cn("flex items-center gap-3 rounded-[var(--radius-md)] border p-3", classes.outer)}>
      <span className={cn("flex size-6 items-center justify-center rounded-full text-white", classes.icon)}>
        {icon}
      </span>
      <span className="flex-1 text-14-bold">{title}</span>
      {actions}
    </div>
  );
}
